import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./index.css";
import App from "./App";
import PrivacyPolicy from "./PrivacyPolicy";
import AppPrivacyPolicy from "./AppPrivacyPolicy";
import AppTermsOfUse from "./AppTermsOfUse";
import TermsAndConditions from "./TermsAndConditions";
import RaspberryPiSetup from "./RaspberryPiSetup";
import Compliance from "./Compliance";
import UserGuide from "./UserGuide";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/app-privacy-policy" element={<AppPrivacyPolicy />} />
        <Route path="/app-terms-of-use" element={<AppTermsOfUse />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/raspberry-setup" element={<RaspberryPiSetup />} />
        <Route path="/support/compliance" element={<Compliance />} />
        <Route path="/support/userguide" element={<UserGuide />} />
      </Routes>
    </Router>
  </React.StrictMode>,
);
